<template>

  <main>

    <Snow />

    <Header :options="animation" :isDesktop="is_desktop" :progress="imagesProgress" :index="active_index" />
    <Sidebar :index="active_index" />

    <full-page ref="fullpage" :options="options" id="fullpage">
      <Intro :isDesktop="is_desktop" :disableBlur="disable_blur" :progress="imagesProgress" :options="animation" />

      <template v-for="n in 13">
        <component :active="(n === active_index || (n + 1) === active_index || (n - 1) === active_index || !is_desktop)" :disableBlur="disable_blur" :key="`Scene${n}`" v-bind:is="`Scene${n}`" :options="animation" :copy="translations[n]" :isDesktop="is_desktop"></component>
      </template>

      <Outro :disableBlur="disable_blur" :isDesktop="is_desktop" :options="animation" />
    </full-page>

  </main>

</template>

<script>
import { mapState } from 'vuex'
import imagesLoaded from 'imagesloaded'
import Scene1 from '@/components/Scene1'
import Scene2 from '@/components/Scene2'
import Scene3 from '@/components/Scene3'
import Scene4 from '@/components/Scene4'
import Scene5 from '@/components/Scene5'
import Scene6 from '@/components/Scene6'
import Scene7 from '@/components/Scene7'
import Scene8 from '@/components/Scene8'
import Scene9 from '@/components/Scene9'
import Scene10 from '@/components/Scene10'
import Scene11 from '@/components/Scene11'
import Scene12 from '@/components/Scene12'
import Scene13 from '@/components/Scene13'
import Intro from '@/components/Intro'
import Outro from '@/components/Outro'
import Snow from '@/components/Snow'
import Sidebar from '@/components/Sidebar'
import Header from '@/components/Header'

export default {
  name: 'Home',

  data () {
    return {
      active_index: 0,
      init_index: [],
      init_index_mobile: [],
      imagesProgress: 0,
      is_desktop: true,
      disable_blur: false,
      responsiveWidth: 1025,
      options: {
        licenseKey: '8DD4F256-07404E01-91871EC1-4D660A91',
        sectionSelector: '.o-section',
        scrollingSpeed: 2500,
        responsiveWidth: 1025,
        responsiveSlides: true,
        onLeave: this.onLeave
      }
    }
  },

  metaInfo () {
    return {
      title: this.globals.title
    }
  },

  mounted () {
    const _this = this
    const imagesCount = document.querySelectorAll('img').length

    this.is_desktop = (window.innerWidth > this.responsiveWidth)
    this.disable_blur = (navigator.userAgent.indexOf('Firefox') > 0 || navigator.userAgent.indexOf('MSIE') > 0 || navigator.userAgent.indexOf('Edge/') > 0 || !this.is_desktop)

    setTimeout(() => {
      this.$anime({
        targets: document.querySelector('.o-section__wrapper'),
        opacity: [0, 1],
        duration: this.animation.fadeInTime,
        easing: this.animation.easing
      })

      this.$anime({
        targets: document.querySelector('.c-logo--intro'),
        opacity: [0, 1],
        scale: [0.95, 1],
        duration: this.animation.durationRegular,
        easing: this.animation.easing
      })
    }, 300)

    this.initSnow()
    const imgLoad = imagesLoaded(document.querySelector('#app'))
    imgLoad.on('done', function (instance) {
      _this.$root.$emit('startScene0')
      _this.imagesProgress = 100

      if (!_this.is_desktop) {
        const sections = document.getElementsByClassName('o-section__figure-wrapper')
        _this.checkVisibleSection(sections)
        document.addEventListener('scroll', () => {
          _this.checkVisibleSection(sections)
        })
      }
    })

    imgLoad.on('progress', function (instance, image) {
      if (image.isLoaded) {
        image.img.classList.add('loaded')
      }
      const countLoadedImages = document.querySelectorAll('img.loaded').length
      _this.imagesProgress = Math.floor(100 * (countLoadedImages / imagesCount))
    })

    this.$root.$on('scrollDown', () => {
      this.$refs.fullpage.api.moveTo(2)
    })

    this.$root.$on('scrollToHome', () => {
      this.$refs.fullpage.api.moveTo(1)
    })

    this.$root.$on('goToSlide', ({ index }) => {
      this.$refs.fullpage.api.moveTo(index)
    })
  },

  methods: {
    onLeave (origin, destination, direction) {
      document.querySelector('.c-sidebar').classList.add('is-disabled')
      this.destroy(origin, destination)
      this.active_index = destination.index
    },

    init (destination) {
      if (this.active_index !== 1 && this.active_index !== 14) {
        this.initSnow()
      }

      if (!this.is_desktop) {
        if (!this.init_index.includes(destination.index)) {
          this.fadeIn(destination)
          this.animateText(destination, 0)
          this.init_index.push(destination.index)
        }
      } else {
        this.fadeIn(destination)
        this.$root.$emit(`startScene${destination.index}`)
        this.animateText(destination, 1500)
      }
    },

    checkVisibleSection (sections) {
      sections.forEach((section, index) => {
        if (this.elementInViewPort(section) && !this.init_index_mobile.includes(index)) {
          this.$anime({
            targets: section,
            opacity: [0, 1],
            duration: this.animation.fadeInTime,
            easing: this.animation.easing
          })

          this.$root.$emit(`startScene${index - 1}`)
          this.init_index_mobile.push(index)
        }
      })
    },

    fadeIn (destination) {
      this.$anime({
        targets: destination.item.querySelector('.o-section__wrapper'),
        opacity: [0, 1],
        duration: this.animation.fadeInTime,
        easing: this.animation.easing,
        complete: function (anim) {
          document.querySelector('.c-sidebar').classList.remove('is-disabled')
        }
      })
    },

    initSnow () {
      this.$anime({
        targets: document.querySelector('.c-snow-wrapper'),
        opacity: [0, 1],
        delay: 200,
        duration: this.animation.fadeOutTime,
        easing: this.animation.easing
      })
    },

    animateText (destination, delay) {
      let textTimeline = this.$anime.timeline({
        easing: this.animation.easing,
        duration: 500
      })

      const delaySecondPart = (this.is_desktop ? 1000 : 200)

      textTimeline
        .add({
          targets: destination.item.querySelectorAll(`div[data-scene="${destination.index}a"] div`),
          opacity: [0, 1],
          translateY: ['30px', '0'],
          delay: this.$anime.stagger(100, {
            start: delay
          })
        })
        .add({
          targets: destination.item.querySelectorAll(`div[data-scene="${destination.index}b"] div`),
          opacity: [0, 1],
          translateY: ['30px', '0'],
          delay: this.$anime.stagger(100, {
            start: delaySecondPart
          })
        })
    },

    destroy (origin, destination) {
      for (const item of this.$anime.running) {
        item.pause()

        if (item.animatables.length > 0) {
          const target = item.animatables[0].target
          item.remove(target)
        }
      }

      const _this = this
      if (this.is_desktop) {
        this.$anime({
          targets: origin.item.querySelector('.o-section__wrapper'),
          opacity: [1, 0],
          duration: this.animation.fadeOutTime,
          easing: this.animation.easing,
          complete: function (anim) {
            _this.init(destination)
          }
        })
      } else {
        this.init(destination)
      }

      this.$anime({
        targets: document.querySelector('.c-snow-wrapper'),
        opacity: 0,
        duration: this.animation.fadeOutTime,
        easing: this.animation.easing
      })
    },

    elementInViewPort (el) {
      let top = el.offsetTop
      let left = el.offsetLeft
      let width = el.offsetWidth
      let height = el.offsetHeight

      while (el.offsetParent) {
        el = el.offsetParent
        top += el.offsetTop
        left += el.offsetLeft
      }

      const bottom = (window.pageYOffset + window.innerHeight) - (window.innerHeight * 0.1)

      return (
        top < (bottom) &&
        left < (window.pageXOffset + window.innerWidth) &&
        (top + height) > window.pageYOffset &&
        (left + width) > window.pageXOffset
      )
    }
  },

  computed: mapState({
    animation: state => state.animation,
    lang: state => state.language,
    translations (state) {
      const lang = this.lang
      return state.translations.scenes[lang]
    },
    globals (state) {
      const lang = this.lang
      return state.translations.general[lang]
    }
  }),

  components: {
    Scene1,
    Scene2,
    Scene3,
    Scene4,
    Scene5,
    Scene6,
    Scene7,
    Scene8,
    Scene9,
    Scene10,
    Scene11,
    Scene12,
    Scene13,
    Intro,
    Outro,
    Snow,
    Sidebar,
    Header
  }
}
</script>
